export default {
  computed: {
    // b-form-datepicker resolves its own date formatting via the Intl API, so it
    // needs a real BCP-47 tag. 'deflt' is our neutral localization -> fall back to en-GB.
    datepickerLocale() {
      return this.$i18n.locale === 'deflt' || !this.$i18n.locale ? 'en-GB' : this.$i18n.locale;
    },

    // The calendar labels are not covered by the locale, they have to be passed in
    // explicitly. Spread onto <b-form-datepicker v-bind="datepickerLabels" />.
    datepickerLabels() {
      return {
        labelPrevDecade: this.$t('Webportal.Datepicker.PrevDecade'),
        labelPrevYear: this.$t('Webportal.Datepicker.PrevYear'),
        labelPrevMonth: this.$t('Webportal.Datepicker.PrevMonth'),
        labelCurrentMonth: this.$t('Webportal.Datepicker.CurrentMonth'),
        labelNextMonth: this.$t('Webportal.Datepicker.NextMonth'),
        labelNextYear: this.$t('Webportal.Datepicker.NextYear'),
        labelNextDecade: this.$t('Webportal.Datepicker.NextDecade'),
        labelToday: this.$t('Webportal.Datepicker.Today'),
        labelSelected: this.$t('Webportal.Datepicker.Selected'),
        labelNoDateSelected: this.$t('Webportal.Datepicker.NoDateSelected'),
        labelCalendar: this.$t('Webportal.Datepicker.Calendar'),
        labelNav: this.$t('Webportal.Datepicker.Nav'),
        labelHelp: this.$t('Webportal.Datepicker.Help'),
        labelTodayButton: this.$t('Webportal.Datepicker.TodayButton'),
        labelResetButton: this.$t('Webportal.Datepicker.ResetButton'),
        labelCloseButton: this.$t('Webportal.Datepicker.CloseButton'),
      };
    },
  },
};
